import { API_REQUEST } from "../..";
import { setProfile, setToken } from "../../../../utils/pip";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addBootCampAPI,
  adminLoginAPI,
  adminProfileEndPointURL,
  adminGetAllTicketsAPI,
  adminDashboardAPI,
  bootcampsAPI,
  cloneBootcampAPI,
  coachiesAPI,
  commonBootcamps,
  createNuterraAPI,
  createSpeakerImageAPI,
  createWebinarAPI,
  createWorkshopAPI,
  createWorkshopSpeakerImageAPI,
  deleteNuterraAPI,
  deleyeWebinarAPI,
  deleyeWorkshopAPI,
  fetchAdminAllWebinar,
  getAllFreelancersEndPointURL,
  getAllHireTalentEndPointURL,
  getHireTalentDetailsEndPointURL,
  getAllWebinarListAPI,
  getAllWorkshopAPI,
  getBookingListAPI,
  nuterraAPI,
  offersAPI,
  toggleBootcampStatusAPI,
  toggleNuterraStatusAPI,
  toggleWorkshopStatusAPI,
  updateAdminWorkshopAPI,
  updateAdminWorkshopSpeakerImageAPI,
  updateBootCampAPI,
  updateBootcampImagesAPI,
  updateCoachStatusAPI,
  updateNuterraDataAPI,
  updateSpeakerImageAPI,
  updateWebinarAPI,
  updateWorkshopAPI,
  updateWorkshopSpeakerImageAPI,
  workNuterraBookingsAPI,
} from "../../../../routes/apiurls";

// auth-signin
export const authSignin = createAsyncThunk("auth-signin", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: adminLoginAPI,
      method: "POST",
      data: payload,
    });

    setToken("admin", response?.data?.token);
    setProfile("admin", response?.data?.adminData);
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const fetchAdminProfile = createAsyncThunk(
  "admin-profile",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: adminProfileEndPointURL,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchCoachies = createAsyncThunk(
  "fetch-couchies",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: coachiesAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchAllFreelancer = createAsyncThunk(
  "fetch-all-freelancer",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: getAllFreelancersEndPointURL,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchAdminDashboard = createAsyncThunk(
  "fetch-admin-dashboard",
  async () => {
    try {
      const response = await API_REQUEST({
        url: adminDashboardAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "admin",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchAllHireTalent = createAsyncThunk(
  "fetch-all-hire-talent",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: getAllHireTalentEndPointURL,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchHireTalentDetails = createAsyncThunk(
  "fetch-hire-talent-details",
  async (id) => {
    try {
      const response = await API_REQUEST({
        url: `${getHireTalentDetailsEndPointURL}${id}`,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const updateCoachStatus = createAsyncThunk(
  "update-couch-status",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateCoachStatusAPI,
        data: payload,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const getWebinarAllData = createAsyncThunk(
  "fetch-webinar",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: getAllWebinarListAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchBootcamps = createAsyncThunk("fetch-bootcamps", async () => {
  try {
    const response = await API_REQUEST({
      url: bootcampsAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) { }
});

export const fetchOffers = createAsyncThunk("fetch-offers", async () => {
  try {
    const response = await API_REQUEST({
      url: offersAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) { }
});
export const fetchNuterra = createAsyncThunk("fetch-nuterra", async () => {
  try {
    const response = await API_REQUEST({
      url: nuterraAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) { }
});

export const addBootCamps = createAsyncThunk("add-bootcamp", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: addBootCampAPI,
      data: payload,
      method: "POST",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const updateBootCamps = createAsyncThunk("update-bootcamp", async (props) => {
  const { payload, callback, param } = props;
  try {
    const response = await API_REQUEST({
      url: updateBootCampAPI + param,
      data: payload,
      method: "PATCH",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const updateBootcampImage = createAsyncThunk("update-bootcamp-images", async (props) => {
  const { payload, id, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateBootcampImagesAPI + id,
      data: payload,
      method: "POST",
      isSuccessToast: false
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});


export const deleteBootcamp = createAsyncThunk(
  "delete-bootcamps",
  async (props) => {
    const { callback, payload } = props;
    try {
      const response = await API_REQUEST({
        url: bootcampsAPI + "/" + payload,
        method: "DELETE",
        isSuccessToast: false,
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const cloneBootcamp = createAsyncThunk(
  "clone-bootcamp",
  async (props) => {
    const { callback, payload } = props;
    try {
      const response = await API_REQUEST({
        url: cloneBootcampAPI + "/" + payload,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);


export const fetchBootcampDetails = createAsyncThunk(
  "fetch-bootcamp-detail",
  async (props) => {
    const { payload } = props;
    try {
      const response = await API_REQUEST({
        url: commonBootcamps + "/" + payload,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchBookingDetails = createAsyncThunk("fetch-booking-details", async () => {
  try {
    const response = await API_REQUEST({
      url: getBookingListAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) {
    console.log({ error });
  };
});

export const addWebinarData = createAsyncThunk("add-webinar", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: createWebinarAPI,
      data: payload,
      method: "POST",
      isSuccessToast: false,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const createSpeakerImageData = createAsyncThunk("add-speaker", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: createSpeakerImageAPI,
      data: payload,
      method: "POST",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// Add Workshop
export const addWorkshopData = createAsyncThunk("add-workshop", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: createWorkshopAPI,
      data: payload,
      method: "POST",
      isSuccessToast: false,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const updateWorkshopData = createAsyncThunk("update-workshop", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateWorkshopAPI,
      data: payload,
      method: "POST",
      isSuccessToast: false,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const createWorkshopSpeakerImageData = createAsyncThunk("add-workshop-speaker", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: createWorkshopSpeakerImageAPI,
      data: payload,
      method: "POST",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const updateWorkshopSpeakerImageData = createAsyncThunk("update-workshop-speaker", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateWorkshopSpeakerImageAPI,
      data: payload,
      method: "POST",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const getAllWebinarAdminData = createAsyncThunk("fetch-admiin-webinar", async () => {
  try {
    const response = await API_REQUEST({
      url: fetchAdminAllWebinar,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) {
    console.log({ error });
  };
});

export const deleteWebinar = createAsyncThunk(
  "delete-webinars",
  async (props) => {
    const { callback, payload } = props;
    try {
      const response = await API_REQUEST({
        url: deleyeWebinarAPI + payload,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const deleteWorkshop = createAsyncThunk(
  "delete-workshop",
  async (props) => {
    const { callback, payload } = props;
    try {
      const response = await API_REQUEST({
        url: deleyeWorkshopAPI + payload,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const updateWebinarData = createAsyncThunk("update-webinar", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateWebinarAPI,
      data: payload,
      method: "PATCH",
      isSuccessToast: false,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const updateSpeakerImageData = createAsyncThunk("update-speaker", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateSpeakerImageAPI,
      data: payload,
      method: "PATCH",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const getAllWorkshopAdminData = createAsyncThunk("fetch-admiin-workshop", async () => {
  try {
    const response = await API_REQUEST({
      url: getAllWorkshopAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) {
    console.log({ error });
  };
});


export const updateAdminWorkshopSpeakerImageData = createAsyncThunk("update-admin-workshop-speaker", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateAdminWorkshopSpeakerImageAPI,
      data: payload,
      method: "PATCH",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  };
});

export const updateAdminWorkshopData = createAsyncThunk("update-admin-workshop", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateAdminWorkshopAPI,
      data: payload,
      method: "PATCH",
      isSuccessToast: false,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  };
});

export const fetchAdminTickets = createAsyncThunk(
  "fetch-admin-tickets",
  async () => {
    try {
      const response = await API_REQUEST({
        url: adminGetAllTicketsAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "admin",
      });
      return response;
    } catch (error) {}
  }
);

export const createNuterraData = createAsyncThunk("create-nuterra-data", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: createNuterraAPI,
      data: payload,
      method: "POST",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const updateNuterraData = createAsyncThunk("update-nuterra-data", async (props) => {
  const { payload, callback, id } = props;
  try {
    const response = await API_REQUEST({
      url: updateNuterraDataAPI + id,
      data: payload,
      method: "PUT",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const deleteNuterra = createAsyncThunk(
  "delete-nuterra",
  async (props) => {
    const { callback, payload } = props;
    try {
      const response = await API_REQUEST({
        url: deleteNuterraAPI + payload,
        method: "DELETE",
        isSuccessToast: false,
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const toggleBootcampStatus = createAsyncThunk("toggle-bootcamp-status", async (props) => {
  const { callback, id } = props;
  try {
    const response = await API_REQUEST({
      url: toggleBootcampStatusAPI + id,
      method: "PATCH",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const toggleNuterraStatus = createAsyncThunk("toggle-nuterra-status", async (props) => {
  const { callback, id } = props;
  try {
    const response = await API_REQUEST({
      url: toggleNuterraStatusAPI + id,
      method: "PATCH",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const toggleWorkShopStatus = createAsyncThunk("toggle-workshop-status", async (props) => {
  const { callback, id } = props;
  try {
    const response = await API_REQUEST({
      url: toggleWorkshopStatusAPI + id,
      method: "PATCH",
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

export const fetchWorkNuterraBookings = createAsyncThunk("fetch-work-nuterra-bookings", async (props) => {
  try {

    const response = await API_REQUEST({
      url: workNuterraBookingsAPI,
      method: "GET",
      params: props,
      isSuccessToast: false,
    });
    return response;
  } catch (error) {
    console.log({ error });
  }
});
